import { MenuItem, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { N } from '../number';

export const FormikInputView = (props) => {
  const {
    name,
    label,
    focused,
    disabled,
    className,
    variant = 'outlined',
    items = [],
    type,
    select = false,
    minWith = 200,
    formik,
    multiline,
    rows,
    autoComplete = 'on',
    sx,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      {!formik && <div style={{ border: '1px solid red', color: 'red' }}>pass parent formik variable</div>}
      {formik && (
        <TextField
          sx={{ ...sx, minWidth: minWith }}
          disabled={disabled}
          multiline={multiline}
          rows={rows}
          fullWidth
          autoComplete={autoComplete}
          autoFocus={focused}
          className={className}
          variant={variant}
          label={t(label) || t(name)}
          id={name}
          name={name}
          select={select}
          type={type === 'amount' ? 'number' : type}
          onChange={props.onChange ?? formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[name]} // Apply formatting for 'amount' type
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
          InputProps={{
            endAdornment:
              type === 'amount' ? (
                <Typography color="gray" fontSize={12}>
                  <N>{formik.values[name]}</N>
                </Typography>
              ) : null,
          }}
        >
          {items.map((x) => (
            <MenuItem key={x.id} value={x.id}>
              {x.title}
            </MenuItem>
          ))}
        </TextField>
      )}
    </>
  );
};
